var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 112,
    viewBox: "0 0 96 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5 62.7822H10.5V97.4922C10.5 99.1479 11.5856 100.608 13.1719 101.085C20.7075 103.344 41.8987 109.702 46.9219 111.21C47.625 111.42 48.375 111.42 49.0781 111.21C54.1012 109.702 75.2925 103.344 82.8281 101.085C84.4144 100.608 85.5 99.1479 85.5 97.4922C85.5 88.7997 85.5 62.7822 85.5 62.7822Z",
    fill: "#DCE3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5015 62.7822H48.0015C48.0015 62.7822 47.6378 111.367 48.0015 111.367C48.3653 111.367 48.7271 111.315 49.0796 111.21C54.1028 109.702 75.294 103.344 82.8296 101.085C84.4159 100.608 85.5015 99.1479 85.5015 97.4922C85.5015 88.7997 85.5015 62.7822 85.5015 62.7822Z",
    fill: "#E6ECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.001 74.9491L10.501 62.7822C10.501 62.7822 3.92534 72.5322 0.98534 76.8897C0.65534 77.3791 0.574714 77.9922 0.765964 78.5491C0.959089 79.106 1.39971 79.5391 1.96034 79.7229C9.08346 82.0366 30.1697 88.8879 35.701 90.6841C36.4941 90.9429 37.3641 90.6447 37.8328 89.9529C40.3472 86.2422 48.001 74.9491 48.001 74.9491Z",
    fill: "#F9F9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5 62.7822L48 74.9491C48 74.9491 55.6538 86.2422 58.1681 89.9529C58.6369 90.6447 59.5069 90.9429 60.3 90.6841C65.8313 88.8879 86.9175 82.0366 94.0406 79.7229C94.6012 79.5391 95.0419 79.106 95.235 78.5491C95.4263 77.9922 95.3456 77.3791 95.0156 76.8897C92.0756 72.5322 85.5 62.7822 85.5 62.7822Z",
    fill: "#F9F9FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9246 37.2237C38.4559 36.5356 37.5878 36.2374 36.7946 36.4962C31.2671 38.2906 10.1753 45.1437 3.05214 47.4593C2.49151 47.6412 2.04901 48.0743 1.85776 48.6312C1.66651 49.1881 1.74714 49.8031 2.07714 50.2906C4.78464 54.3068 10.5015 62.7818 10.5015 62.7818L48.0015 50.5737C48.0015 50.5737 41.2665 40.6681 38.9246 37.2237Z",
    fill: "#DCE3F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9244 50.2906C94.2544 49.8031 94.335 49.1881 94.1437 48.6312C93.9525 48.0743 93.51 47.6412 92.9494 47.4593C85.8262 45.1437 64.7344 38.2906 59.2069 36.4962C58.4138 36.2374 57.5456 36.5356 57.0769 37.2237C54.735 40.6681 48 50.5737 48 50.5737L85.5 62.7818C85.5 62.7818 91.2169 54.3068 93.9244 50.2906Z",
    fill: "#F9F9FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5 62.7819L48 50.5737L10.5 62.7819L48 74.9487L85.5 62.7819Z",
    fill: "#DCE3F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 74.9487V50.5737L10.5 62.7819L48 74.9487Z",
    fill: "#E6ECFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4667 55.9589C39.6867 55.4489 38.9835 54.9032 38.3592 54.3314C37.5979 53.632 36.411 53.6826 35.7098 54.4457C35.0104 55.207 35.061 56.3939 35.8242 57.0932C36.591 57.7982 37.4554 58.4695 38.4154 59.0976C39.2817 59.6639 40.4442 59.4201 41.0104 58.5539C41.5767 57.6876 41.3329 56.5251 40.4667 55.9589Z",
    fill: "#2820DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6247 50.1988C34.0678 49.4432 33.5972 48.6838 33.2109 47.9244C32.7422 47.0019 31.6116 46.6344 30.6891 47.1032C29.7666 47.5719 29.3991 48.7025 29.8678 49.625C30.3441 50.5588 30.9216 51.4944 31.6059 52.4225C32.2191 53.255 33.3928 53.4332 34.2272 52.82C35.0597 52.205 35.2378 51.0313 34.6247 50.1988Z",
    fill: "#2820DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8833 42.5466C31.9021 41.791 32.0127 41.0578 32.2152 40.3547C32.5002 39.361 31.9246 38.3203 30.929 38.0353C29.9352 37.7503 28.8946 38.3259 28.6096 39.3216C28.3227 40.3266 28.1615 41.3747 28.1333 42.4528C28.109 43.4878 28.9265 44.3484 29.9615 44.3728C30.9965 44.3991 31.8571 43.5816 31.8833 42.5466Z",
    fill: "#2820DA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7677 36.2841C35.2496 35.8378 35.7896 35.4253 36.3802 35.0522C37.2558 34.4991 37.5183 33.3403 36.9671 32.4666C36.4139 31.591 35.2552 31.3285 34.3796 31.8797C33.5865 32.3803 32.8664 32.9335 32.2196 33.5335C31.4602 34.2366 31.4152 35.4235 32.1183 36.1828C32.8214 36.9422 34.0083 36.9872 34.7677 36.2841Z",
    fill: "#2820DA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7397 33.05C42.6828 32.8756 43.6822 32.7631 44.7359 32.72C45.7709 32.675 46.5734 31.7994 46.5303 30.7662C46.4872 29.7331 45.6115 28.9287 44.5765 28.9719C43.339 29.0244 42.1653 29.1575 41.0572 29.3619C40.0409 29.5512 39.3659 30.53 39.5553 31.5462C39.7428 32.5644 40.7215 33.2375 41.7397 33.05Z",
    fill: "#2820DA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5128 32.9395C53.1122 32.9582 54.6009 32.902 55.9828 32.7801C57.0141 32.6882 57.7772 31.777 57.6853 30.7457C57.5934 29.7163 56.6822 28.9532 55.6509 29.0451C54.3853 29.1557 53.0222 29.2082 51.5559 29.1895C50.5209 29.1782 49.6716 30.0088 49.6603 31.042C49.6472 32.077 50.4778 32.9282 51.5128 32.9395Z",
    fill: "#2820DA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1454 31.6304C64.0017 31.0622 65.5692 30.3347 66.8817 29.5004C67.7535 28.9435 68.0123 27.7847 67.4554 26.911C66.9004 26.0391 65.7398 25.7804 64.866 26.3372C63.8104 27.0085 62.5448 27.586 61.0485 28.0435C60.0604 28.3472 59.5017 29.3954 59.8054 30.3854C60.1073 31.3754 61.1573 31.9322 62.1454 31.6304Z",
    fill: "#2820DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6889 24.2522C72.5739 22.4222 72.9132 20.4872 72.827 18.6216C72.7782 17.5866 71.8989 16.7878 70.8657 16.8366C69.8326 16.8853 69.032 17.7628 69.0807 18.796C69.1407 20.0635 68.912 21.3778 68.312 22.621C67.862 23.5528 68.252 24.676 69.1839 25.126C70.1157 25.576 71.2389 25.1841 71.6889 24.2522Z",
    fill: "#2820DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4949 11.9918C69.128 10.1449 67.2736 8.85869 65.2524 8.44431C64.238 8.23806 63.2461 8.89056 63.038 9.90494C62.8317 10.9193 63.4861 11.9112 64.4986 12.1193C65.6649 12.3574 66.6924 13.1581 67.4817 14.2249C68.0986 15.0556 69.2742 15.2299 70.1049 14.6149C70.9374 13.9981 71.1117 12.8224 70.4949 11.9918Z",
    fill: "#2820DA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 8.80824C48.0288 -2.67988 65.6106 -1.93738 55.375 8.80824H46Z",
    fill: "#DCE3F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 11.7183C48.0288 23.2045 65.6106 22.4639 55.375 11.7183H46Z",
    fill: "#DCE3F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.832 12.1572H58.387C59.422 12.1572 60.262 11.3172 60.262 10.2822C60.262 9.24723 59.422 8.40723 58.387 8.40723H45.832C44.7989 8.40723 43.957 9.24723 43.957 10.2822C43.957 11.3172 44.7989 12.1572 45.832 12.1572Z",
    fill: "#2820DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsEmpty);
export default __webpack_public_path__ + "static/media/products-empty.7ec7fb40a4c2b16980ac1edfe17dc2ba.svg";
export { ForwardRef as ReactComponent };